import { useAtom } from 'jotai';

import { searchAtom, type SearchAtom } from '../atoms';

export const useSearchAtom = (): {
  /**
   * Closes the search box/modal.
   */
  close: () => void;

  /**
   * @see SearchAtom.isOpen
   */
  isOpen: SearchAtom['isOpen'];

  /**
   * Opens the search box/modal.
   */
  open: () => void;
} => {
  const [search, setSearch] = useAtom<SearchAtom>(searchAtom);

  const { isOpen } = search;

  const open: ReturnType<typeof useSearchAtom>['open'] = () => {
    return setSearch({ isOpen: true });
  };

  const close: ReturnType<typeof useSearchAtom>['close'] = () => {
    return setSearch({ isOpen: false });
  };

  return { close, isOpen, open };
};
